<template>
  <div class="menu-title" :class="{ folder: isFolder }">
    <div class="title__label">{{ menuLabel }}</div>
    <div class="title__extra" v-if="!collapse">
      <menu-extra :menu="menu" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'

import MenuExtra from './menu-extra.vue'

const props = withDefaults(
  defineProps<{
    menu?: any
    collapse?: boolean
  }>(),
  {}
)

const emit = defineEmits(['remove'])

const app = useHostAppInstance()

const currentMenu = computed(() => {
  return props.menu || []
})

const isFolder = computed(() => {
  return currentMenu.value.isFolder === true
})

const menuLabel = computed(() => {
  const menu = currentMenu.value
  return isFolder.value ? menu.folderName : menu.itemName
})
</script>

<style lang="scss" scoped>
.menu-title {
  display: flex;
  align-items: center;

  .title__label {
    flex: 1;
  }
}
</style>
